import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum MarketDataFeedSubscriptionFormErrorStatesEnum {
    CreateMarketDataFeedSubscriptionFailed = ErrorStateScheduleEnum.MarketDataFeedSubscriptionFormStatesStartIndex,
    CreateMarketDataFeedSubscriptionSuccess,
    ListUnsubscribedMarketDataFailed,
    AlreadySubscribedAllBundle,
    UpdateMarketDataFeedSubscriptionSuccess,
    UpdateMarketDataFeedSubscriptionFailed,
    UpdateMarketDataFeedSubscriptionFailedNoPermission,
}
